import React, { useRef, useEffect, useState, useContext, useCallback, forwardRef } from 'react';
import { RootStoreContext } from '../../app/stores/rootStore';
import { getScreenOrientation } from '../../app/models/general';
import { broadcastBasePortatritsDimensions } from '../../app/models/broadcast';

interface VideoPlayerProps {
  id: string;
  mediaStream: MediaStream;
  onlyVideo?: boolean;
  onlyAudio?: boolean;
  mirror?: boolean;
  mask?: JSX.Element;
  fullScreen?: boolean;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ mediaStream, onlyVideo, onlyAudio, mirror, mask, id, fullScreen }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const videoDivRef = useRef<HTMLDivElement | null>(null);
  const rootStore = useContext(RootStoreContext);
const { streamingAvailable} = rootStore.broadcastStore;
const [maskWidth, setMaskWidth] = useState<number | null>(null);
const [maskHeight, setMaskHeight] = useState<number | null>(null);
const [errorMex, setErrorMex] = useState("");
const [orizzontalMargin, setOrizzontalMargin] = useState("");
const [verticalMargin, setVerticalMargin] = useState("");
const [ratio , setRatio] = useState<number | undefined>(undefined);
const [isVideoPlaying, setIsVideoPlaying] = useState(false);

useEffect(() => {
  if(!videoRef.current) return;
  const videoElement = videoRef.current;

  const handleVideoPlaying = () => {
    setIsVideoPlaying(true);
    // setIsVideoActive(true);
  };
  // const handleVideoPause = () => 
  //   setIsVideoActive(false);
  // const handleVideoEnded = () => 
  //   setIsVideoActive(false);
  // const handleVideoError = () => 
  //   setIsVideoActive(false);

  videoElement.addEventListener('playing', handleVideoPlaying);
  // videoElement.addEventListener('pause', handleVideoPause);
  // videoElement.addEventListener('ended', handleVideoEnded);
  // videoElement.addEventListener('error', handleVideoError);

  // Rimuovi i listener quando il componente viene smontato
  return () => {
    videoElement.removeEventListener('playing', handleVideoPlaying);
    // videoElement.removeEventListener('pause', handleVideoPause);
    // videoElement.removeEventListener('ended', handleVideoEnded);
    // videoElement.removeEventListener('error', handleVideoError);
  };
}, [videoRef]);

  useEffect(() => {
    // if(streamingAvailable){
      console.log("streaming avilable : "+ streamingAvailable)
      if (videoRef.current) {
        if (onlyVideo === true) {
          const videoTracks = mediaStream.getVideoTracks();
          if (videoTracks.length > 0) {
            const videoOnlyStream = new MediaStream([videoTracks[0]]);
            let ratio = videoTracks[0].getSettings().aspectRatio;
            if(ratio === 1.33 || ratio === 1.77 || ratio === 1.78)
              setRatio(ratio);
            else
              setRatio(1.33);
            videoRef.current.srcObject = videoOnlyStream;
          } else {
            console.error("No video tracks available in the media stream");
          }
        } else if (onlyAudio === true){
          const audioTracks = mediaStream.getAudioTracks();
          if (audioTracks.length > 0) {
            const audioOnlyStream = new MediaStream([audioTracks[0]]);
            videoRef.current.srcObject = audioOnlyStream;
          } else {
            console.error("No audio tracks available in the media stream");
          }
        } else 
          videoRef.current.srcObject = mediaStream;
          console.log("videoRef.current.srcObject caricato");
      // }
    }
  }, [mediaStream, onlyAudio, onlyVideo, streamingAvailable]);

  const handleOptimization = useCallback(() => {

    if (videoRef.current && videoDivRef && videoDivRef.current && isVideoPlaying) {
      console.log("handleOptimization start");
      let widthDifference = 0;
      let heightDifference = 0;
      let width = videoDivRef.current.clientWidth;
      let height = videoDivRef.current.clientHeight;
      
      widthDifference = width - videoRef.current.clientWidth;
      heightDifference = height - videoRef.current.clientHeight;

      let currentWidth = videoRef.current.clientWidth < window.innerWidth ? videoRef.current.clientWidth : window.innerWidth;
      let currentHeight = videoRef.current.clientHeight < window.innerHeight ? videoRef.current.clientHeight : window.innerHeight;
      
      let dimentions : broadcastBasePortatritsDimensions= {
        width: 0,
        height: 0,
        orizzontalMargin: 0,
        verticalMargin: 0,
      };
      if(ratio){
        if(fullScreen === true){

          // if(currentWidth >= (currentHeight * ratio)){
            // currentWidth = currentHeight * ratio;
            let totalOrizzontalMargin = (width - currentWidth);
            setOrizzontalMargin((totalOrizzontalMargin / 2).toString());
            dimentions.orizzontalMargin = totalOrizzontalMargin;
          // } else {
          //   dimentions.orizzontalMargin = 0;
          //   setOrizzontalMargin("0");
          // }
          
          // if(currentHeight >= (currentWidth / ratio)){
          //   currentHeight = currentWidth / ratio;
            let totalVerticalMargin = (height - currentHeight);
            setVerticalMargin((totalVerticalMargin / 2).toString());
            dimentions.verticalMargin = totalVerticalMargin;
          // } else{
          //   dimentions.verticalMargin = 0;
          //   setVerticalMargin("0");
          // }
        } else {
          setVerticalMargin("0");
          setOrizzontalMargin("0");
        }

        // if(heightDifference < 0)
        //   heightDifference = 0;

          if (widthDifference <= heightDifference) {
            dimentions.width = currentWidth;
            dimentions.height = (currentWidth) / ratio;
            setMaskWidth((currentWidth));
            setMaskHeight(((currentWidth) / ratio));
          } else {
              dimentions.width = ((currentHeight) * ratio);
              dimentions.height = currentHeight
            setMaskHeight((currentHeight));
            setMaskWidth(((currentHeight) * ratio));
          }
      } else {
        setMaskWidth(null);
        setMaskHeight(null);
        setOrizzontalMargin("0");
        setVerticalMargin("0");
      }
    }
    console.log("handleOptimization end");
  }, [videoRef, videoDivRef, isVideoPlaying, ratio, fullScreen]);

  // useEffect(() => {
    
  // },[fullScreen]);

  useEffect(() => {
  
    const handleResize = () => {
      handleOptimization();
      console.log("handleResize called");
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener("orientationchange", handleResize, false);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener("orientationchange", handleResize, false);
    };
  }, [handleOptimization]);

  // useEffect(() => {
  //   setPortaitsBaseDim(() => {return portaitsBaseDimention});
  //   handleOptimization();
  // }, [handleOptimization, portaitsBaseDimention]);

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      setTimeout(() => {
        handleOptimization();
        console.log("ResizeObserver called");
      }, 0);
    });
    
    // const observer = new ResizeObserver(handleOptimization);
    if (videoDivRef && videoDivRef.current) {
      observer.observe(videoDivRef.current);
    }
    return () => {
      observer.disconnect();
    };
  },[]);

  return (
    <>
      {onlyAudio === true ? (
        <audio ref={videoRef} autoPlay />
      ) : (
        <div ref={videoDivRef} style={{ position: 'relative', width: "100%", height:'100%', display: "flex", alignItems: "center", padding: "5px"}}>
            <video
            className={'video ' + (mirror === true ? 'mirror' : '')}
            autoPlay
            style={{
              width: '100%',
              height: '100%',
              maxWidth: '100%',
              backgroundColor: '#373737',
              maxHeight: maskHeight && maskHeight < ((window.innerHeight*94)/100) ? `${(maskHeight).toString() + "px"}` : "94vh",
              objectFit: 'contain', // Modifica la proprietà object-fit secondo le tue esigenze
            }}
            ref={videoRef}
            muted
          />
          
          {/* Mask */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: maskWidth ? (maskWidth + 10).toString() + "px" : "100%",
              height: maskHeight ? (maskHeight + 10).toString() + "px" : "100%",
              maxWidth: "100vw",
              maxHeight: (maskHeight && videoDivRef && videoDivRef.current ) ? maskHeight < videoDivRef.current.clientHeight ? `${(maskHeight).toString() + "px"}` : videoDivRef.current.clientHeight : "100%",
              margin: errorMex !== '' ? '': verticalMargin + "px " + orizzontalMargin + "px",
              pointerEvents: 'none', // Permette agli eventi di passare attraverso la maschera
            }}
          >
            {mask}
          </div>
        </div>
      )}
    </>
  );
};

export default VideoPlayer;